import styled from 'styled-components';

export const Avatar = styled.img`
  border-radius: 50%;
  height: 40px;
  width: 40px;
`;

